export const filterPhone = (num: string) => {
  return 'tel:' + num.replace(/[^0-9+]/g, '')
}
